<template>
  <div
    id="swap"
    style="background-color:white"
    v-show="!loaded"
    :style="{ 'pointer-events': !gesture ? 'auto' : 'none' }"
  >
    <img
      :src="isamnet"
      style="width:100%"
      @load="onLoad"
    />
    <div class="swap-wrapper">
      <div class="swap-container">
        <div
          id="swap-card-top"
          class="swap-card"
          style="transform: scale(0.8);"
        >
          <a :href="creative.swap[0].landing_page" target="_blank">
            <img :src="creative.swap[0].image_url" @load="onLoad" />
          </a>
        </div>
        <div
          id="swap-card-bottom"
          class="swap-card"
          style="transform: scale(0.8); left: 59px; top: 49px;"
        >
          <a :href="creative.swap[1].landing_page" target="_blank">
            <img :src="creative.swap[1].image_url" @load="onLoad" />
          </a>
        </div>
      </div>
    </div>
    <img
      src="https://cdn.aralego.net/rich_media/assets/banner/bg2.png"
      style="width:100%"
      @load="onLoad"
    />
  </div>
</template>

<script>
import mixPreview from "@/components/mixins/preview.js";
import mixMobile from "@/components/mixins/mobile.js";
export default {
  data() {
    return {
      loaded: 4,
      ADWIDTH: 300,
      ADHEIGHT: 250,
    };
  },
  computed: {
    isamnet() {
      let domain = window.location.hostname
      let isAmnet = "https://cdn.aralego.net/rich_media/assets";
      if(domain === 'prism.amnet.tw') {
        isAmnet += '/amnet/bg2.png'
      } else {
        isAmnet += '/banner/bg1.png'
      }
      return isAmnet
    }
  },
  async mounted() {
    this.viewport();
    await this.$nextTick();
    const container = document.querySelector(".swap-container");

    this.addEvent(window, "DOMContentLoaded", this.swap_event);
    this.addEvent(window, "load", this.swap_event);
    this.addEvent(window, "scroll", this.swap_event);
    this.addEvent(window, "resize", this.swap_event);
  },
  mixins: [mixPreview, mixMobile],
  methods: {
    swap_event() {
      const container = document.querySelector(".swap-container");
      var inViewPercent = this.elementInViewport(container);
      this.eleTranform(inViewPercent);
    },
    elementInViewport(el) {
      var top = el.offsetTop;
      var left = el.offsetLeft;
      var width = el.offsetWidth;
      var height = el.offsetHeight;
      var treshold = this.ADHEIGHT - 50;

      while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
      }
      var inview = Math.max(
        0,
        Math.min(
          100,
          Math.floor(
            ((((top + top + height) / 2 -
              window.pageYOffset -
              window.innerHeight +
              treshold) *
              -1) /
              treshold) *
              100
          )
        )
      );

      return inview;
    },
    eleTranform(v) {
      //v should be from 0-100
      //init scale
      const container = document.querySelector(".swap-container");
      const top_card = document.querySelector("#swap-card-top");
      const bottom_card = document.querySelector("#swap-card-bottom");

      var initScale = 0.8;
      top_card.style.transform =
        "scale(" + (initScale + ((1 - initScale) * v) / 100) + ")";
      bottom_card.style.transform =
        "scale(" + (initScale + ((1 - initScale) * v) / 100) + ")";
      bottom_card.style.left =
        Math.floor((this.ADWIDTH * (1 - initScale) * (100 - v)) / 100) + "px";

      var lrec2Top = Math.floor(
        this.ADHEIGHT * (v < (1 - initScale) * 100 ? 1 - initScale : v / 100)
      );
      bottom_card.style.top = lrec2Top + "px";
      container.style.height = this.ADHEIGHT + lrec2Top + "px";
    },
  },
};
</script>

<style lang="sass" scoped>
.swap-wrapper
  width: 320px
  margin: auto
  .swap-container
    min-height: 250px
    width: 300px
    position: relative
    z-index: 1
    overflow: visible
    .swap-card
      height: 250px
      width: 300px
      position: absolute
      transform-origin: top left
      overflow: hidden
      img
        width: 100%
        display: block
        cursor: pointer
    #swap-card-top
      z-index: 1003
    #swap-card-bottom
      z-index: 1002
</style>
